<template>
  <div class="gold-panel"> 
    <p>24k 99.5 {{$t('purity')}}</p>
    <div class="text">
      <img src="../assets/images/gold-text.png" />
      <span>SAFEGOLD</span>
    </div>
    <span>1 {{$t('gram')}}</span>
    <span class="gram-rs-gold">₹ {{ goldPrice ? goldPrice : 0}}</span>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  props:{
    goldPrice: {
      type: Number,
      required: true,
      default: 0
    }
  }
};
</script>